import {
  GetStaticProps,
  GetStaticPropsContext,
  InferGetStaticPropsType,
  NextPage,
} from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
  WhistleblowingPolicyDocument,
  WhistleblowingPolicyQuery,
  WhistleblowingPolicyQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import EnhancedPolicyPageWrapper from '@/components/policies/EnhancedPolicyPageWrapper';
import { Seo } from '@/components/Seo';

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext,
) => {
  const client = initializeApollo();
  const { locale } = context;

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: WhistleblowingPolicyDocument });
  await client.query({ query: FooterDocument });

  const { data: whistleblowingPolicy } = await client.query<
    WhistleblowingPolicyQuery,
    WhistleblowingPolicyQueryVariables
  >({
    query: WhistleblowingPolicyDocument,
    variables: { locale: locale || 'en' },
  });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument, variables: { locale: locale || 'en' } });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument, variables: { locale: locale || 'en' } });

  return addApolloState(client, {
    props: {
      footerData,
      headerData,
      whistleblowingPolicy,
    },
  });
};

const WhistleblowingPolicy: NextPage<
  InferGetStaticPropsType<typeof getStaticProps>
> = ({ footerData, headerData, whistleblowingPolicy }) => (
  <Layout invertedColor footerData={footerData} headerData={headerData}>
    <Seo
      seo={whistleblowingPolicy.whistleblowingPolicy?.data?.attributes?.seo}
    />
    <EnhancedPolicyPageWrapper
      data={
        whistleblowingPolicy.whistleblowingPolicy?.data?.attributes?.policies
      }
    />
  </Layout>
);

export default WhistleblowingPolicy;
